import gql from 'graphql-tag';

export default gql(`
query AllSubscribers($limit: Int, $nextToken: String) {
  listSubscribers (limit: $limit, nextToken: $nextToken){
    subscribers {
      id
      email
      status
      notified
      createdAt
    }
    nextToken
  }
}`);



// WEBPACK FOOTER //
// ./src/graphql/QueryAllSubscribers.js